import React from 'react';

const Card = ({ title, children }) => {
    return (
        <div className="bg-white shadow-lg rounded-lg p-6">
            <h2 className="text-xl font-bold mb-4 text-gray-800">{title}</h2>
            <div>{children}</div>
        </div>
    );
};

export default Card;
